export class WrongSaleError extends Error {}
